<script>
	import { getContext, createEventDispatcher, onDestroy } from 'svelte'
	import { storeData, storeElementID, storeSelectedIcon } from '../library/scripts/Store.svelte'
	import { get_element_tags } from '../builder/builderUtils'
	import { styles } from '../library/scripts/styles'
	import Slider from '../library/LayoutStuff/Slider.svelte'

	export let ID = 0
	export let range = 5
	export let initialValue = 100
	export let showValue = '1'
	export let unit = '%'
	export let showUnit = true

	ID = parseInt(ID)
	range = parseInt(range)
	initialValue = parseInt(initialValue)

	// allow only the range to enter
	$: if (initialValue > range) initialValue = range

	const globals = getContext('globals')
	const valueColor = 'black'
	const valueFs = globals.fsXS
	const mobile = globals.mobile

	let sizeValue = initialValue
	let selectedElement
	let selectedIcon
	let config
	let blocks

	let dispatch = createEventDispatcher()

	const stoSelectedIcon = storeSelectedIcon.subscribe((value) => {
		selectedIcon = value
	})
	const stoElementID = storeElementID.subscribe((value) => {
		selectedElement = value
	})

	const stoData = storeData.subscribe((value) => {
		if (value) {
			config = value
			blocks = value.blocks
		}
	})

	$: if (selectedElement) {
		set_initial_values()
	}

	//calculate the size from input
	const calc_input_size = () => {
		dispatch('sizechange', { value: initialValue })
	}

	const keyDownNumber = (e) => {
		if (e.keyCode === 13) calc_input_size()
	}

	//calculate the size from slider
	const calc_slider_size = (e) => {
		sizeValue = e.detail.value
		dispatch('sizechange', { value: sizeValue })
	}

	function set_initial_values() {
		const tags = get_element_tags(selectedElement)
		let elementcoverSlider = false
		let elementGallery = false
		let elementBlock = false
		let elementBlockTitle = false
		let elementColumn = false
		let elementColumnTitle = false
		let elementColumnText = false
		let elementColumnImage = false
		let elementSingleImageBlock = false
		let elementNavbar = false
		let elementContact = false
		let elementBooking = false
		let elementDrinks = false
		let elementFoods = false
		let elementRooms = false

		const blockID = tags[0]
		const columnID = tags[1]
		const elementTag = tags[2]
		const elementTags = elementTag.split(' ')

		//check which element is selected
		if (blockID === 'drinks') {
			elementDrinks = true
		}

		if (blockID === 'foods') {
			elementFoods = true
		}

		if (blockID === 'rooms') {
			elementRooms = true
		}

		if (blockID === 'cover-slider') {
			elementcoverSlider = true
		}

		if (blockID === 'gallery') {
			elementGallery = true
		}

		if (blockID === 'Navbar') {
			elementNavbar = true
		}

		if (blockID === 'Contact') {
			elementContact = true
		}

		if (blockID === 'booking') {
			elementBooking = true
		}
		if (
			blockID !== 'cover-slider' &&
			blockID !== 'gallery' &&
			blockID !== 'rooms' &&
			columnID !== 'drinks' &&
			columnID !== 'foods' &&
			columnID !== 'singleImageBlock' &&
			columnID !== 'booking' &&
			elementTags.length === 1
		) {
			if (elementTags[0] === '') elementBlock = true
			if (elementTags[0] === 'BlockTitle') elementBlockTitle = true
		}

		if (columnID === 'singleImageBlock') {
			elementSingleImageBlock = true
		}

		if (elementTags.length === 2) {
			elementColumn = true
		}

		if (elementTags.length === 3) {
			if (elementTags[2] === 'Title') elementColumnTitle = true
			if (elementTags[2] === 'Text') elementColumnText = true
			if (elementTags[2] === 'Image') elementColumnImage = true
		}

		if (elementcoverSlider) set_values('coverSlider', blockID, null)
		if (elementGallery) set_values('gallery', blockID, null)
		if (elementBlock) set_values('block', blockID, null)
		if (elementBlockTitle) set_values('blockTitle', blockID, null)
		if (elementColumn) set_values('column', blockID, columnID)
		if (elementColumnTitle) set_values('columnTitle', blockID, columnID)
		if (elementColumnText) set_values('columnText', blockID, columnID)
		if (elementColumnImage) set_values('columnImage', blockID, columnID)
		if (elementSingleImageBlock) set_values('singleImageBlock', blockID, null)
		if (elementNavbar) set_values('navbar', blockID, null)
		if (elementContact) set_values('contact', blockID, null)
		if (elementBooking) set_values('booking', blockID, null)
		if (elementDrinks) set_values('drinks', blockID, null)
		if (elementFoods) set_values('foods', blockID, null)
		if (elementRooms) set_values('rooms', blockID, null)
	}

	const set_values = (cmd, element, columnID) => {
		if (element !== 'Navbar' && element !== 'Contact') {
			blocks.forEach((block) => {
				if (block.blockName === element) {
					switch (ID) {
						case 3:
							if (cmd === 'block' || cmd === 'coverSlider') {
								sizeValue = block.marginTop
								initialValue = sizeValue
							}

							if (cmd === 'blockTitle') {
								sizeValue = block.blockTitleMarginTop
								initialValue = sizeValue
							}

							if (cmd === 'column') {
								sizeValue = block.content[columnID - 1].marginTop
								initialValue = sizeValue
							}

							if (cmd === 'columnTitle') {
								sizeValue = block.content[columnID - 1].titleMarginTop
								initialValue = sizeValue
							}

							if (cmd === 'columnImage') {
								sizeValue = block.content[columnID - 1].imageMarginTop
								initialValue = sizeValue
							}

							if (cmd === 'columnText') {
								sizeValue = block.content[columnID - 1].textMarginTop
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibMarginTop
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								sizeValue = block.marginTop
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.blockMarginTop
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.blockMarginTop
								initialValue = sizeValue
							}

							if (cmd === 'booking') {
								sizeValue = block.marginTop
								initialValue = sizeValue
							}

							break

						case 4:
							if (cmd === 'block' || cmd === 'coverSlider' || cmd === 'gallery') {
								sizeValue = block.marginBottom
								initialValue = sizeValue
							}

							if (cmd === 'blockTitle') {
								sizeValue = block.blockTitleMarginBottom
								initialValue = sizeValue
							}

							if (cmd === 'column') {
								sizeValue = block.content[columnID - 1].marginBottom
								initialValue = sizeValue
							}

							if (cmd === 'columnTitle') {
								sizeValue = block.content[columnID - 1].titleMarginBottom
								initialValue = sizeValue
							}

							if (cmd === 'columnImage') {
								sizeValue = block.content[columnID - 1].imageMarginBottom
								initialValue = sizeValue
							}

							if (cmd === 'columnText') {
								sizeValue = block.content[columnID - 1].textMarginBottom
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibMarginBottom
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.blockMarginBottom
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.blockMarginBottom
								initialValue = sizeValue
							}

							if (cmd === 'booking') {
								sizeValue = block.marginBottom
								initialValue = sizeValue
							}
							break

						case 5:
							if (cmd === 'block' || cmd === 'coverSlider') {
								sizeValue = block.padding
								initialValue = sizeValue
							}

							if (cmd === 'blockTitle') {
								sizeValue = block.blockTitlePadding
								initialValue = sizeValue
							}

							if (cmd === 'column') {
								sizeValue = block.content[columnID - 1].padding
								initialValue = sizeValue
							}

							if (cmd === 'columnTitle') {
								sizeValue = block.content[columnID - 1].titlePadding
								initialValue = sizeValue
							}

							if (cmd === 'columnImage') {
								sizeValue = block.content[columnID - 1].imagePadding
								initialValue = sizeValue
							}

							if (cmd === 'columnText') {
								sizeValue = block.content[columnID - 1].textPadding
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibPadding
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								sizeValue = block.padding
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.blockPadding
								initialValue = sizeValue
							}
							if (cmd === 'rooms') {
								sizeValue = block.blockPadding
								initialValue = sizeValue
							}

							if (cmd === 'booking') {
								sizeValue = block.padding
								initialValue = sizeValue
							}
							break

						case 6:
							//borders
							if (cmd === 'coverSlider') {
								if (selectedIcon === 'icon1') sizeValue = block.sliderBLwidth
								if (selectedIcon === 'icon2') sizeValue = block.sliderBTwidth
								if (selectedIcon === 'icon3') sizeValue = block.sliderBRwidth
								if (selectedIcon === 'icon4') sizeValue = block.sliderBBwidth
								if (selectedIcon === 'icon5') sizeValue = block.sliderBLwidth
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								if (selectedIcon === 'icon1') sizeValue = block.sliderBLwidth
								if (selectedIcon === 'icon2') sizeValue = block.sliderBTwidth
								if (selectedIcon === 'icon3') sizeValue = block.sliderBRwidth
								if (selectedIcon === 'icon4') sizeValue = block.sliderBBwidth
								if (selectedIcon === 'icon5') sizeValue = block.sliderBLwidth
								initialValue = sizeValue
							}

							if (cmd === 'columnImage') {
								if (selectedIcon === 'icon1') sizeValue = block.content[columnID - 1].imageBorderLeftWidth
								if (selectedIcon === 'icon2') sizeValue = block.content[columnID - 1].imageBorderTopWidth
								if (selectedIcon === 'icon3') sizeValue = block.content[columnID - 1].imageBorderRightWidth
								if (selectedIcon === 'icon4') sizeValue = block.content[columnID - 1].imageBorderBottomWidth
								if (selectedIcon === 'icon5') sizeValue = block.content[columnID - 1].imageBorderLeftWidth
								initialValue = sizeValue
							}
							if (cmd === 'column') {
								sizeValue = block.content[columnID - 1].borderTopWidth
							}

							if (cmd === 'singleImageBlock') {
								if (selectedIcon === 'icon1') sizeValue = block.sibBorderLeftWidth
								if (selectedIcon === 'icon2') sizeValue = block.sibBorderTopWidth
								if (selectedIcon === 'icon3') sizeValue = block.sibBorderRightWidth
								if (selectedIcon === 'icon4') sizeValue = block.sibBorderBottomWidth
								if (selectedIcon === 'icon5') sizeValue = block.sibBorderLeftWidth
								initialValue = sizeValue
							}

							if (cmd === 'block') {
								if (selectedIcon === 'icon1') sizeValue = block.borderLeftWidth
								if (selectedIcon === 'icon2') sizeValue = block.borderTopWidth
								if (selectedIcon === 'icon3') sizeValue = block.borderRightWidth
								if (selectedIcon === 'icon4') sizeValue = block.borderBottomWidth
								if (selectedIcon === 'icon5') sizeValue = block.borderLeftWidth
								initialValue = sizeValue
							}

							if (cmd === 'blockTitle') {
								sizeValue = block.blockTitleShadowOffsetX
								initialValue = sizeValue
							}

							if (cmd === 'columnTitle') {
								sizeValue = block.content[columnID - 1].titleColumnShadowOffsetX
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.blockTitleHeight
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								if (selectedIcon === 'icon1') sizeValue = block.borderLeftWidth
								if (selectedIcon === 'icon2') sizeValue = block.borderTopWidth
								if (selectedIcon === 'icon3') sizeValue = block.borderRightWidth
								if (selectedIcon === 'icon4') sizeValue = block.borderBottomWidth
								if (selectedIcon === 'icon5') sizeValue = block.borderLeftWidth
								initialValue = sizeValue
							}

							if (cmd === 'booking') {
								sizeValue = block.blockBoxShadowX
								initialValue = sizeValue
							}

							break

						case 7:
							if (cmd === 'block') {
								sizeValue = block.borderTopRadius
								initialValue = sizeValue
							}

							if (cmd === 'column') {
								sizeValue = block.content[columnID - 1].borderTopRadius
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibBorderTopRadius
								initialValue = sizeValue
							}

							if (cmd === 'blockTitle') {
								sizeValue = block.blockTitleShadowOffsetY
								initialValue = sizeValue
							}

							if (cmd === 'columnTitle') {
								sizeValue = block.content[columnID - 1].titleColumnShadowOffsetY
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								sizeValue = block.blockTitleShadowOffsetY
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.blockTitleMarginTop
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.borderTopRadius
								initialValue = sizeValue
							}

							if (cmd === 'booking') {
								sizeValue = block.blockBoxShadowY
								initialValue = sizeValue
							}

							break

						case 8:
							if (cmd === 'block') {
								sizeValue = block.borderBottomRadius
								initialValue = sizeValue
							}

							if (cmd === 'column') {
								sizeValue = block.content[columnID - 1].borderBottomRadius
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibBorderBottomRadius
								initialValue = sizeValue
							}

							if (cmd === 'blockTitle' || cmd === 'gallery') {
								sizeValue = block.blockTitleShadowBlur
								initialValue = sizeValue
							}

							if (cmd === 'columnTitle') {
								sizeValue = block.content[columnID - 1].titleColumnShadowBlur
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.blockTitleMarginBottom
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.borderBottomRadius
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.blockBoxShadowY
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.blockBoxShadowY
								initialValue = sizeValue
							}

							if (cmd === 'booking') {
								sizeValue = block.blockBoxShadowBlur
								initialValue = sizeValue
							}
							break

						case 9:
							if (cmd === 'block') {
								sizeValue = block.blockGridGap
								initialValue = sizeValue
							}
							if (cmd === 'gallery') {
								sizeValue = block.galleryRightBorderBottomRadius
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibTextHeight
								initialValue = sizeValue
							}

							if (cmd === 'coverSlider') {
								sizeValue = block.sliderShadowOffsetX
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.blockTitlePadding
								initialValue = sizeValue
							}

							if (cmd === 'booking') {
								sizeValue = block.blockTitleHeight
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.blockBoxShadowBlur
								initialValue = sizeValue
							}

							if (cmd === 'columnTitle') {
								sizeValue = block.content[columnID - 1].titlePosTop
								initialValue = sizeValue
							}
							break

						case 10:
							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibImageShadowOffsetY
								initialValue = sizeValue
							}

							if (cmd === 'coverSlider') {
								sizeValue = block.sliderShadowOffsetY
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								sizeValue = block.sliderBTradius
								initialValue = sizeValue
							}

							if (cmd === 'drinks') {
								if (selectedIcon === 'icon1') sizeValue = block.borderLeftWidth
								if (selectedIcon === 'icon2') sizeValue = block.borderTopWidth
								if (selectedIcon === 'icon3') sizeValue = block.borderRightWidth
								if (selectedIcon === 'icon4') sizeValue = block.borderBottomWidth
								if (selectedIcon === 'icon5') sizeValue = block.borderLeftWidth
								initialValue = sizeValue
							}

							if (cmd === 'booking') {
								sizeValue = block.blockTitleMarginTop
								initialValue = sizeValue
							}

							if (cmd === 'columnTitle') {
								sizeValue = block.content[columnID - 1].titlePosLeft
								initialValue = sizeValue
							}
							break

						case 11:
							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibImageShadowBlur
								initialValue = sizeValue
							}

							if (cmd === 'coverSlider') {
								sizeValue = block.sliderShadowBlur
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								sizeValue = block.sliderBBradius
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.borderTopRadius
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.blockTitleTXTShadowOffsetX
								initialValue = sizeValue
							}

							if (cmd === 'booking') {
								sizeValue = block.blockTitleShadowOffsetX
								initialValue = sizeValue
							}

							if (cmd === 'columnText') {
								sizeValue = block.content[columnID - 1].textPosTop
								initialValue = sizeValue
							}

							break
						case 12:
							if (cmd === 'columnImage') {
								sizeValue = block.content[columnID - 1].imageBorderTopRadius
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibTextWidth
								initialValue = sizeValue
							}

							if (cmd === 'coverSlider') {
								sizeValue = block.sliderInsetShadowOffsetX
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								sizeValue = block.sliderHeight
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.borderBottomRadius
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.blockTitleTXTShadowOffsetY
								initialValue = sizeValue
							}

							if (cmd === 'booking') {
								sizeValue = block.blockTitleShadowOffsetY
								initialValue = sizeValue
							}

							if (cmd === 'columnText') {
								sizeValue = block.content[columnID - 1].textPosLeft
								initialValue = sizeValue
							}
							break

						case 13:
							if (cmd === 'columnImage') {
								sizeValue = block.content[columnID - 1].imageWidth
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								sizeValue = block.galleryLeftShadowBlur
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibImageWidth
								initialValue = sizeValue
							}

							if (cmd === 'coverSlider') {
								sizeValue = block.sliderInsetShadowOffsetY
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.blockBoxShadowY
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.blockTitleTXTShadowBlur
								initialValue = sizeValue
							}

							if (cmd === 'booking') {
								sizeValue = block.blockTitleShadowBlur
								initialValue = sizeValue
							}

							break

						case 14:
							if (cmd === 'columnImage') {
								sizeValue = block.content[columnID - 1].boxShadowX
								initialValue = sizeValue
							}

							if (cmd === 'column') {
								sizeValue = block.content[columnID - 1].columnBoxShadowX
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibImageShadowOffsetX
								initialValue = sizeValue
							}

							if (cmd === 'coverSlider') {
								sizeValue = block.sliderInsetShadowBlur
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.blockBoxShadowBlur
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.roomsMT
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								sizeValue = block.sliderWidth
								initialValue = sizeValue
							}

							if (cmd === 'booking') {
								sizeValue = block.inputShadowX
								initialValue = sizeValue
							}
							break

						case 15:
							if (cmd === 'block') {
								sizeValue = block.blockBoxShadowY
								initialValue = sizeValue
							}
							if (cmd === 'columnImage') {
								sizeValue = block.content[columnID - 1].boxShadowY
								initialValue = sizeValue
							}

							if (cmd === 'column') {
								sizeValue = block.content[columnID - 1].columnBoxShadowY
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibShadowOffsetY
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								sizeValue = block.galleryShadowY
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.blockTitleShadowOffsetY
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.roomsMB
								initialValue = sizeValue
							}

							if (cmd === 'booking') {
								sizeValue = block.inputShadowY
								initialValue = sizeValue
							}
							break

						case 16:
							if (cmd === 'block') {
								sizeValue = block.blockBoxShadowBlur
								initialValue = sizeValue
							}
							if (cmd === 'columnImage') {
								sizeValue = block.content[columnID - 1].boxShadowBlur
								initialValue = sizeValue
							}

							if (cmd === 'column') {
								sizeValue = block.content[columnID - 1].columnBoxShadowBlur
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibShadowBlur
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								sizeValue = block.galleryShadowBlur
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.blockTitleShadowOffsetY
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.roomsP
								initialValue = sizeValue
							}

							if (cmd === 'booking') {
								sizeValue = block.inputShadowBlur
								initialValue = sizeValue
							}
							break

						case 17:
							if (cmd === 'columnImage') {
								sizeValue = block.content[columnID - 1].imageBorderBottomRadius
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								sizeValue = block.galleryRightBorderBottomRadius
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibTextLeft
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.blockTitleShadowBlur
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.roomsBRT
								initialValue = sizeValue
							}
							break

						case 18:
							if (cmd === 'coverSlider') {
								sizeValue = block.sliderWidth
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								if (selectedIcon === 'icon11') sizeValue = block.galleryRightBorderLeftWidth
								if (selectedIcon === 'icon12') sizeValue = block.galleryRightBorderTopWidth
								if (selectedIcon === 'icon13') sizeValue = block.galleryRightBorderRightWidth
								if (selectedIcon === 'icon14') sizeValue = block.galleryRightBorderBottomWidth
								if (selectedIcon === 'icon15') sizeValue = block.galleryRightBorderLeftWidth
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibTitleWidth
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.menuContainerMT
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.roomsBRB
								initialValue = sizeValue
							}
							break

						case 19:
							if (cmd === 'columnText') {
								sizeValue = block.content[columnID - 1].textWidth
								initialValue = sizeValue
							}
							if (cmd === 'coverSlider') {
								sizeValue = block.sliderInsetWidth
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								if (selectedIcon === 'icon11') sizeValue = block.sibTitleBorderLeftWidth
								if (selectedIcon === 'icon12') sizeValue = block.sibTitleBorderTopWidth
								if (selectedIcon === 'icon13') sizeValue = block.sibTitleBorderRightWidth
								if (selectedIcon === 'icon14') sizeValue = block.sibTitleBorderBottomWidth
								if (selectedIcon === 'icon15') sizeValue = block.sibTitleBorderLeftWidth
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.menuContainerMB
								initialValue = sizeValue
							}

							break

						case 20:
							if (cmd === 'columnText') {
								sizeValue = block.content[columnID - 1].textHeight
								initialValue = sizeValue
							}
							if (cmd === 'coverSlider') {
								sizeValue = block.sliderInsetHeight
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibHeight
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.menuConatainerP
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.roomsBW
								initialValue = sizeValue
							}

							break

						case 21:
							if (cmd === 'coverSlider') {
								sizeValue = block.sliderInsetLeft
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibTitleLeft
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.menuWidth
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.blockTitleShadowOffsetY
								initialValue = sizeValue
							}

							if (cmd === 'booking') {
								sizeValue = block.blockTitlebarY
								initialValue = sizeValue
							}
							break

						case 22:
							if (cmd === 'coverSlider') {
								sizeValue = block.sliderInsetTop
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibTitleTop
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.menuMT
								initialValue = sizeValue
							}

							if (cmd === 'contact') {
								config.blocks.forEach((block, index) => {
									if (block.blockName === 'contact') {
										sizeValue = config.blocks[index].titlePadding
										initialValue = sizeValue
									}
								})
							}

							if (cmd === 'rooms') {
								sizeValue = block.blockTitleShadowBlur
								initialValue = sizeValue
							}

							if (cmd === 'booking') {
								sizeValue = block.blockTitlebarB
								initialValue = sizeValue
							}

							break

						case 23:
							if (cmd === 'coverSlider') {
								if (selectedIcon === 'icon6') sizeValue = block.sliderInsetBLwidth
								if (selectedIcon === 'icon7') sizeValue = block.sliderInsetBTwidth
								if (selectedIcon === 'icon8') sizeValue = block.sliderInsetBRwidth
								if (selectedIcon === 'icon9') sizeValue = block.sliderInsetBBwidth
								if (selectedIcon === 'icon10') sizeValue = block.sliderInsetBLwidth
								initialValue = sizeValue
							}

							//gallery left column border
							if (cmd === 'gallery') {
								if (selectedIcon === 'icon6') sizeValue = block.galleryLeftBorderLeftWidth
								if (selectedIcon === 'icon7') sizeValue = block.galleryLeftBorderTopWidth
								if (selectedIcon === 'icon8') sizeValue = block.galleryLeftBorderRightWidth
								if (selectedIcon === 'icon9') sizeValue = block.galleryLeftBorderBottomWidth
								if (selectedIcon === 'icon10') sizeValue = block.galleryLeftBorderLeftWidth
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								if (selectedIcon === 'icon6') sizeValue = block.sibImageBorderLeftWidth
								if (selectedIcon === 'icon7') sizeValue = block.sibImageBorderTopWidth
								if (selectedIcon === 'icon8') sizeValue = block.sibImageBorderRightWidth
								if (selectedIcon === 'icon9') sizeValue = block.sibImageBorderBottomWidth
								if (selectedIcon === 'icon10') sizeValue = block.sibImageBorderLeftWidth
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.menuMB
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.roomsSX
								initialValue = sizeValue
							}

							if (cmd === 'contact') {
								config.blocks.forEach((block, index) => {
									if (block.blockName === 'contact') {
										sizeValue = config.blocks[index].titleShadowX
										initialValue = sizeValue
									}
								})
							}

							if (cmd === 'booking') {
								sizeValue = block.selectionSX
								initialValue = sizeValue
							}

							break

						case 24:
							if (cmd === 'coverSlider') {
								sizeValue = block.sliderInsetBTradius
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								sizeValue = block.galleryLeftBorderTopRadius
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibImageBorderTopRadius
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.menuSX
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.roomsSY
								initialValue = sizeValue
							}

							if (cmd === 'contact') {
								config.blocks.forEach((block, index) => {
									if (block.blockName === 'contact') {
										sizeValue = config.blocks[index].titleShadowY
										initialValue = sizeValue
									}
								})
							}

							if (cmd === 'booking') {
								sizeValue = block.selectionSY
								initialValue = sizeValue
							}

							break

						case 25:
							if (cmd === 'coverSlider') {
								sizeValue = block.sliderInsetBBradius
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								sizeValue = block.galleryLeftBorderBottomRadius
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibImageBorderBottomRadius
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.menuSY
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.roomsSB
								initialValue = sizeValue
							}

							if (cmd === 'contact') {
								config.blocks.forEach((block, index) => {
									if (block.blockName === 'contact') {
										sizeValue = config.blocks[index].titleShadowBlur
										initialValue = sizeValue
									}
								})
							}

							if (cmd === 'booking') {
								sizeValue = block.selectionSB
								initialValue = sizeValue
							}
							break

						case 26:
							if (cmd === 'coverSlider') {
								switch (block.sliderSpeed) {
									case 2000:
										sizeValue = 5
										break

									case 3000:
										sizeValue = 4
										break

									case 4000:
										sizeValue = 3
										break

									case 5000:
										sizeValue = 2
										break

									case 6000:
										sizeValue = 1
										break

									case 7000:
										sizeValue = 0
										break
								}

								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibTextTop
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								sizeValue = block.sliderInsetTitleHeight
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.menuSB
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.roomsIMGW
								initialValue = sizeValue
							}

							if (cmd === 'contact') {
								if (selectedIcon === 'icon16') sizeValue = block.borderLeftWidth
								if (selectedIcon === 'icon17') sizeValue = block.borderTopWidth
								if (selectedIcon === 'icon18') sizeValue = block.borderRightWidth
								if (selectedIcon === 'icon19') sizeValue = block.borderBottomWidth
								if (selectedIcon === 'icon20') sizeValue = block.borderLeftWidth
								initialValue = sizeValue
							}

							if (cmd === 'booking') {
								if (selectedIcon === 'icon1') sizeValue = block.borderLeftWidth
								if (selectedIcon === 'icon2') sizeValue = block.borderTopWidth
								if (selectedIcon === 'icon3') sizeValue = block.borderRightWidth
								if (selectedIcon === 'icon4') sizeValue = block.borderBottomWidth
								if (selectedIcon === 'icon5') sizeValue = block.borderLeftWidth
								initialValue = sizeValue
							}
							break

						case 27:
							if (cmd === 'coverSlider') {
								switch (block.sliderPause) {
									case 2:
										sizeValue = 0
										break

									case 3:
										sizeValue = 1
										break

									case 4:
										sizeValue = 2
										break

									case 5:
										sizeValue = 3
										break

									case 6:
										sizeValue = 4
										break

									case 7:
										sizeValue = 5
										break
								}

								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								if (selectedIcon === 'icon16') sizeValue = block.sibTextBorderLeftWidth
								if (selectedIcon === 'icon17') sizeValue = block.sibTextBorderTopWidth
								if (selectedIcon === 'icon18') sizeValue = block.sibTextBorderRightWidth
								if (selectedIcon === 'icon19') sizeValue = block.sibTextBorderBottomWidth
								if (selectedIcon === 'icon20') sizeValue = block.sibTextBorderLeftWidth
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.menuP
								initialValue = sizeValue
							}

							if (cmd === 'contact') {
								sizeValue = block.borderTopRadius
								initialValue = sizeValue
							}

							if (cmd === 'booking') {
								if (selectedIcon === 'icon6') sizeValue = block.selectionBLW
								if (selectedIcon === 'icon7') sizeValue = block.selectionBTW
								if (selectedIcon === 'icon8') sizeValue = block.selectionBRW
								if (selectedIcon === 'icon9') sizeValue = block.selectionBBW
								if (selectedIcon === 'icon10') sizeValue = block.selectionBLW
								initialValue = sizeValue
							}

							break

						case 28:
							if (cmd === 'columnText') {
								sizeValue = block.content[columnID - 1].titleHeight
								initialValue = sizeValue
							}
							if (cmd === 'coverSlider') {
								sizeValue = block.sliderHeight
								initialValue = sizeValue
							}

							if (cmd === 'columnTitle') {
								sizeValue = block.content[columnID - 1].titleHeight
								initialValue = sizeValue
							}

							if (cmd === 'drinks') {
								if (selectedIcon === 'icon6') sizeValue = block.menuBLW
								if (selectedIcon === 'icon7') sizeValue = block.menuBTW
								if (selectedIcon === 'icon8') sizeValue = block.menuBRW
								if (selectedIcon === 'icon9') sizeValue = block.menuBBW
								if (selectedIcon === 'icon10') sizeValue = block.menuBLW
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.blockTitleHeight
								initialValue = sizeValue
							}

							if (cmd === 'booking') {
								sizeValue = block.borderBottomRadius
								initialValue = sizeValue
							}
							break

						case 29:
							if (cmd === 'columnText') {
								sizeValue = block.content[columnID - 1].titleHeight
								initialValue = sizeValue
							}
							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibTitleHeight
								initialValue = sizeValue
							}

							if (cmd === 'blockTitle') {
								sizeValue = block.blockTitleHeight
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								if (selectedIcon === 'icon6') sizeValue = block.sliderInsetTitleBLwidth
								if (selectedIcon === 'icon7') sizeValue = block.sliderInsetTitleBTwidth
								if (selectedIcon === 'icon8') sizeValue = block.sliderInsetTitleBRwidth
								if (selectedIcon === 'icon9') sizeValue = block.sliderInsetTitleBBwidth
								if (selectedIcon === 'icon10') sizeValue = block.sliderInsetTitleBLwidth
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.menuBRT
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.blockTitleMarginTop
								initialValue = sizeValue
							}

							if (cmd === 'contact') {
								sizeValue = block.titleHeight
								initialValue = sizeValue
							}

							break

						case 30:
							if (cmd === 'columnTitle') {
								sizeValue = block.content[columnID - 1].titleColumnBorderRadius
								initialValue = sizeValue
							}
							if (cmd === 'gallery') {
								sizeValue = block.galleryLeftMarginTop
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibTitleBorderTopRadius
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.menuBRB
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.blockTitleMarginBottom
								initialValue = sizeValue
							}

							if (cmd === 'contact') {
								sizeValue = block.titleMT
								initialValue = sizeValue
							}
							break

						case 31:
							if (cmd === 'gallery') {
								sizeValue = block.galleryLeftMarginBottom
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibTitleBorderTopRadius
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.menuBGB
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.blockTitlePadding
								initialValue = sizeValue
							}

							if (cmd === 'contact') {
								sizeValue = block.titleMB
								initialValue = sizeValue
							}

							if (cmd === 'columnTitle') {
								sizeValue = block.content[columnID - 1].titleWidth
								initialValue = sizeValue
							}
							break

						case 32:
							if (cmd === 'gallery') {
								sizeValue = block.galleryLeftPadding
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibTitleShadowOffsetX
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.categoryPadding
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.roomsIMGX
								initialValue = sizeValue
							}
							break

						case 33:
							if (cmd === 'gallery') {
								sizeValue = block.galleryRightMarginTop
								initialValue = sizeValue
							}
							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibTitleShadowOffsetY
								initialValue = sizeValue
							}

							if (cmd === 'drinks' || cmd === 'foods') {
								sizeValue = block.categoryMargin
								initialValue = sizeValue
							}

							if (cmd === 'rooms') {
								sizeValue = block.roomsIMGY
								initialValue = sizeValue
							}
							break

						case 34:
							if (cmd === 'gallery') {
								sizeValue = block.galleryRightMarginBottom
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibTitleShadowBlur
								initialValue = sizeValue
							}
							if (cmd === 'rooms') {
								sizeValue = block.roomsIMGB
								initialValue = sizeValue
							}
							break

						case 35:
							if (cmd === 'gallery') {
								sizeValue = block.galleryRightPadding
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibTextBorderTopRadius
								initialValue = sizeValue
							}
							break

						case 36:
							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibTextBorderBottomRadius
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								sizeValue = block.galleryRightShadowOffsetX
								initialValue = sizeValue
							}
							break

						case 37:
							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibTextShadowOffsetX
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								sizeValue = block.galleryRightShadowOffsetY
								initialValue = sizeValue
							}
							break

						case 38:
							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibTextShadowOffsetY
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								sizeValue = block.galleryRightShadowBlur
								initialValue = sizeValue
							}
							break

						case 39:
							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibTextShadowBlur
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								sizeValue = block.sliderInsetTitleBTradius
								initialValue = sizeValue
							}
							break

						case 40:
							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibImageLeft
								initialValue = sizeValue
							}

							if (cmd === 'gallery') {
								sizeValue = block.sliderInsetTitleBBradius
								initialValue = sizeValue
							}
							break

						case 41:
							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibImageTop
								initialValue = sizeValue
							}

							break

						case 42:
							if (cmd === 'gallery') {
								sizeValue = block.galleryRightBorderTopRadius
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = config.logo.imageHeight
								initialValue = sizeValue
							}
							break

						case 43:
							//open slot
							break

						case 44:
							//empty slot
							break

						case 45:
							if (cmd === 'gallery') {
								sizeValue = block.sliderInsetTextHeight
								initialValue = sizeValue
							}

							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibTitleTXTSX
								initialValue = sizeValue
							}
							break

						case 46:
							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibTitleTXTSY
								initialValue = sizeValue
							}
							break
						case 47:
							if (cmd === 'singleImageBlock') {
								sizeValue = block.sibTitleTXTSB
								initialValue = sizeValue
							}
							break

						case 48:
							if (cmd === 'gallery') {
								if (selectedIcon === 'icon12') sizeValue = block.sliderInsetTextBTwidth
								if (selectedIcon === 'icon14') sizeValue = block.sliderInsetTextBBwidth
								initialValue = sizeValue
							}
							break
						case 49:
							if (cmd === 'gallery') {
								sizeValue = block.sliderInsetTextBTradius
								initialValue = sizeValue
							}
							break

						case 50:
							if (cmd === 'gallery') {
								sizeValue = block.sliderInsetTextBBradius
								initialValue = sizeValue
							}
							break

						case 51:
							//empty slot
							break

						case 52:
							//empty slot
							break

						case 53:
							//empty slot
							break

						case 54:
							//empty slot
							break

						case 55:
							//empty slot
							break
					}
				}
			})
		} else {
			switch (ID) {
				case 3:
					if (cmd === 'navbar') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'navbar') {
								sizeValue = config.blocks[index].marginTop
								initialValue = sizeValue
							}
						})
					}

					if (cmd === 'contact') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'contact') {
								sizeValue = config.blocks[index].marginTop
								initialValue = sizeValue
							}
						})
					}
					break

				case 4:
					if (cmd === 'navbar') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'navbar') {
								sizeValue = config.blocks[index].marginBottom
								initialValue = sizeValue
							}
						})
					}

					if (cmd === 'contact') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'contact') {
								sizeValue = config.blocks[index].marginBottom
								initialValue = sizeValue
							}
						})
					}
					break

				case 5:
					if (cmd === 'navbar') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'navbar') {
								sizeValue = config.blocks[index].paddingLeft
								initialValue = sizeValue
							}
						})
					}

					if (cmd === 'contact') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'contact') {
								sizeValue = config.blocks[index].padding
								initialValue = sizeValue
							}
						})
					}
					break

				case 6:
					if (cmd === 'navbar') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'navbar') {
								sizeValue = config.blocks[index].paddingRight
								initialValue = sizeValue
							}
						})
					}

					if (cmd === 'contact') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'contact') {
								sizeValue = config.blocks[index].shadowX
								initialValue = sizeValue
							}
						})
					}
					break

				case 7:
					if (cmd === 'navbar') {
						if (selectedIcon === 'icon1') {
							config.blocks.forEach((block, index) => {
								if (block.blockName === 'navbar') {
									sizeValue = config.blocks[index].borderTopWidth
								}
							})
						}
						if (selectedIcon === 'icon2') {
							config.blocks.forEach((block, index) => {
								if (block.blockName === 'navbar') {
									sizeValue = config.blocks[index].borderBottomWidth
								}
							})
						}
						initialValue = sizeValue
					}

					if (cmd === 'contact') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'contact') {
								sizeValue = config.blocks[index].shadowY
								initialValue = sizeValue
							}
						})
					}
					break

				case 8:
					if (cmd === 'navbar') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'navbar') {
								sizeValue = config.blocks[index].shadowOffsetY
								initialValue = sizeValue
							}
						})
					}

					if (cmd === 'contact') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'contact') {
								sizeValue = config.blocks[index].shadowBlur
								initialValue = sizeValue
							}
						})
					}
					break

				case 9:
					if (cmd === 'navbar') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'navbar') {
								sizeValue = config.blocks[index].shadowBlur
								initialValue = sizeValue
							}
						})
					}

					if (cmd === 'contact') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'contact') {
								sizeValue = config.blocks[index].inputShadowX
								initialValue = sizeValue
							}
						})
					}
					break

				case 10:
					if (cmd === 'contact') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'contact') {
								sizeValue = config.blocks[index].inputShadowY
								initialValue = sizeValue
							}
						})
					}
					break

				case 11:
					if (cmd === 'contact') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'contact') {
								sizeValue = config.blocks[index].inputShadowBlur
								initialValue = sizeValue
							}
						})
					}
					break

				case 12:
					if (cmd === 'contact') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'contact') {
								sizeValue = config.blocks[index].containerLeftPaddingTop
								initialValue = sizeValue
							}
						})
					}
					break

				case 13:
					if (cmd === 'contact') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'contact') {
								sizeValue = config.blocks[index].containerLeftPaddingBottom
								initialValue = sizeValue
							}
						})
					}
					break

				case 14:
					if (cmd === 'contact') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'contact') {
								sizeValue = config.blocks[index].buttonBorderRadius
								initialValue = sizeValue
							}
						})
					}
					break

				case 15:
					if (cmd === 'contact') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'contact') {
								sizeValue = config.blocks[index].infoLeftPadding
								initialValue = sizeValue
							}
						})
					}
					break

				case 16:
					if (cmd === 'contact') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'contact') {
								sizeValue = config.blocks[index].mapWidth
								initialValue = sizeValue
							}
						})
					}
					break

				case 17:
					if (cmd === 'contact') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'contact') {
								sizeValue = config.blocks[index].mapHeight
								initialValue = sizeValue
							}
						})
					}
					break

				case 18:
					if (cmd === 'contact') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'contact') {
								sizeValue = config.blocks[index].mapBorderWidth
								initialValue = sizeValue
							}
						})
					}
					break

				case 19:
					if (cmd === 'contact') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'contact') {
								sizeValue = config.blocks[index].mapShadowX
								initialValue = sizeValue
							}
						})
					}
					break

				case 20:
					if (cmd === 'contact') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'contact') {
								sizeValue = config.blocks[index].mapShadowY
								initialValue = sizeValue
							}
						})
					}
					break

				case 21:
					if (cmd === 'contact') {
						config.blocks.forEach((block, index) => {
							if (block.blockName === 'contact') {
								sizeValue = config.blocks[index].mapShadowBlur
								initialValue = sizeValue
							}
						})
					}
					break
			}
		}
	}

	onDestroy(() => {
		stoElementID
		stoData
		stoSelectedIcon
	})
</script>

<svelte:window on:keydown={keyDownNumber} />
{#if config}
	<main>
		{#if showValue === '1'}
			<div class="slider_value" use:styles={{ valueColor, valueFs }}>
				<input
					type="number"
					id="slider_{ID}"
					bind:value={initialValue}
					on:input={calc_input_size}
					min="0"
					max={range}
					use:styles={{ valueColor, valueFs }}
				/>
				{#if showUnit}
					<div class="unit">{unit}</div>
				{/if}
			</div>
		{/if}
		{#if !mobile}
			<div class="sliderContainer">
				<Slider
					width="100"
					height="20"
					sizeUnit="px"
					{unit}
					{ID}
					{range}
					{initialValue}
					on:sliderMove={calc_slider_size}
				/>
			</div>
		{/if}
	</main>
{/if}

<style>
	input {
		color: var(--valueColor);
		font-size: var(--valueFs);
		background-color: transparent;
		width: 50%;
		border: 1px solid black;
	}
	main {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 10px;
		width: clamp(100px, 17vw, 250px);
	}

	.sliderContainer {
		display: flex;
		justify-content: center;
		width: 100%;
	}

	.slider_value {
		display: flex;
		width: 100%;
		justify-content: center;
		align-items: center;
		color: var(--valueColor);
		font-size: var(--valueFs);
	}

	.unit {
		margin-left: 10px;
	}
</style>
